module.exports = __webpack_public_path__ + "media/images/front/brands/atelier/atelier_1-dbc548e880ee4cf60925801609c64d93.jpg";